var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
export var ToggleTextStyle = styled.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    :hover {\n        cursor: pointer;\n        text-decoration: underline;\n    }\n"], ["\n    :hover {\n        cursor: pointer;\n        text-decoration: underline;\n    }\n"])));
var templateObject_1;
